import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { OkAloneService } from 'src/app/ok-alone.service';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-start-end',
  templateUrl: './start-end.component.html',
  styleUrls: ['./start-end.component.scss']
})
export class StartEndComponent implements OnInit {

  shiftreminders: any;

  view: any;
  sort = 'newest';
  formGroup = new FormGroup ({
    search: new FormControl('',[])
  });

  pagination = { page: 1, pageSize: 1, itemCount: 1, totalPages: 1, pageArray: [1], totalCount: 1 };

  constructor(private router: Router, private route: ActivatedRoute, public okService: OkAloneService) { }

  ngOnInit(): void {

    this.pagination.page = 1;
    this.getShiftReminders();

  }

  getShiftReminders(){

    let filter = {
      sort: this.sort,
      search: this.formGroup.value.search,
      page: this.pagination.page,
    }

    //console.log('filter', filter);

    this.okService.get("shiftreminders",filter)
    .subscribe((data) => {

      this.shiftreminders = data.body;
      this.pagination = this.okService.setPagination(data.headers) ?? this.pagination;

      //console.log("getShiftReminders", data);

    });

  }

  changePage(){
    this.getShiftReminders();
  }

  updateFilter(){
    if(this.formGroup.valid){
      this.getShiftReminders();
    }
  }

}
